import {
  resetTenantVlansByBuilding,
  resetTenantVlansByNas,
  resetTenantVlansByUnit,
} from 'shared/api/tenant-radius';

export const vlanResetTarget = {
  building: 'building',
  nas: 'nas',
  unit: 'unit',
};

export const vlanDistributionTypes = ['standard', 'ruckus'];

// Updates tenant device radius records to match unit's vlan.
export async function resetDeviceVlans(
  id,
  request,
  notification,
  name,
  target = vlanResetTarget.building,
) {
  let response;
  switch (target) {
    case vlanResetTarget.building:
      response = await request(resetTenantVlansByBuilding(id));
      break;
    case vlanResetTarget.nas:
      response = await request(resetTenantVlansByNas(id));
      break;
    case vlanResetTarget.unit:
      response = await request(resetTenantVlansByUnit(id));
      break;
    default:
      response = null;
  }

  if (!response) return false;

  const { num_updated: n } = response;

  if (n > 0) {
    notification.pushSuccess(`${n} tenant vlan${n > 1 ? 's' : ''} reset for ${name}`);
  } else {
    notification.pushSuccess(`No tenant vlans needed reset for ${name}`);
  }
  return true;
}

// source: https://stackoverflow.com/a/53279821
export const isValidIp = (value) => (/^(?:(?:^|\.)(?:2(?:5[0-5]|[0-4]\d)|1?\d?\d)){4}$/.test(value));
